const version = "3.12.0";
export const crossFlowSupportAttributes = {
  version
};
export const enrichWithPackageDetails = event => {
  const attributes = {
    ...(event.attributes || {}),
    crossFlowSupport: crossFlowSupportAttributes
  };
  return {
    ...event,
    attributes
  };
};